import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ProductRateForm from './ProductRateForm'

import { storeProductRate } from '../services'
import { handleError } from '../../../helpers'

export default function NewProductRateModal({ visible, onClose, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm()

	const onSubmit = values => {
		storeProductRate(values)	
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(handleError)
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Agregar nueva tarifa</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ProductRateForm 
						register={register}
						errors={errors}
					/>
					<Button color="primary" type="submit">
						Agregar tarifa
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}